import React, {useEffect} from "react"
import Helper from "../LocServices/Helper"

import CheckButton from "react-validation/build/button";
import SimpleFinderDelete from "./SimpleFinderDelete"


export default function SimpleFinderContent (props) {
    useEffect(()=> {
        //reset Edit, Delete buttons influence
            return () => {
            props.update_loc_simpleFinderMode("show");
          };
    },[])

    if (typeof(props.data) === "undefined") return error()
    if (props.data.length === 0) return <></>
    if (props.mode !== "show") return <></>

    const row = props.data[0]
    const {update_loc_simpleFinderMode, reqLocId_delete, isLoading, token} = props

    return (
        <>
        {show_content(row, update_loc_simpleFinderMode, reqLocId_delete, isLoading, token)}
        {/* <Helper props={props} /> */}
        </>
    )

}

const show_content = (row, update_loc_simpleFinderMode, reqLocId_delete, isLoading, token) => {



    //console.log(row)
    return (
        <div className="card border" style={{backgroundColor: "transparent"}}>
        <div className="card-body">
            <h5 className="card-title">Location #{row.id}</h5>

            <p className="card-text">
            <strong>Tags:</strong>  {row.gr_tags}
            </p>

            <p className="card-text">
            <strong>URL:</strong> <a href={row.url} target="_blank"> {row.url} </a>
            </p>

            <p className="card-text">
            <strong>Description:</strong>  {wrapLinkContent(row.description)}
            </p>

            <p className="card-text">
            <strong>Text:</strong>  {wrapLinkContent(row.text)}
            </p>

            <hr />

            <p className="card-text">
            <strong>Chat ID:</strong>  {row.chat_id} <br />
            <strong>Message ID:</strong>  {row.message_id} <br />
            <strong>From ID:</strong>  {row.from_id} <br />
            <strong>Username:</strong>  {row.username} <br />
            <strong>Created_at:</strong>  {row.created_at} <br />
            </p>

            <div className="simple-finder__button-container">
{/*                 <button type="button" className="sf-btn--decor btn btn-outline-danger"
                    onClick={()=>{
                        //update_loc_simpleFinderMode('delete')
                        alert("Are you sure?")
                    }
                }
                >
                    {isLoading && (
                        <span className="spinner-border spinner-border-sm"></span>
                    )}

                    Delete
                </button> */}
                <SimpleFinderDelete 
                    isLoading={isLoading}
                    reqLocId_delete={reqLocId_delete}
                    locationId = {row.id}
                    token = {token}
                />

                <button type="button" className="sf-btn--decor btn btn-outline-primary"
                    onClick={()=>{update_loc_simpleFinderMode('edit')}}
                >
                    {isLoading && (
                        <span className="spinner-border spinner-border-sm"></span>
                    )}

                    Edit
                </button>
            </div>
        </div>
    </div>
    )
}

const error = (row) => {
    return (
        <div className="card border" style={{backgroundColor: "transparent"}}>
        <div className="card-body">
            <h5 className="card-title" style={{color: "pink"}}>Error</h5>
            <p className="card-text">
                It looks like wrong number
            </p>

        </div>
    </div>
    )
}

/* const wrapLinkContent = (content) => {
    
    const urlRegex = /\b(https?:\/\/[^\s]+)/g;
    //const text = "Text: улица Чингиза Айтматова, 58 Астана https://yandex.ru/navi?whatshere%5Bpoint%5D=71.37350717913684%2C51.157716914725434&whatshere%5Bzoom%5D=16.715677&ll=71.37350717913684%2C51.15771691433038&z=16.715677&si=my3dq82w71a4nb4rf5nzwp5nxg";
    let urlWrappedText = content.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });

    return <span dangerouslySetInnerHTML={{ __html: urlWrappedText }} />;
  }; */

  const wrapLinkContent = (content) => {
    
    const urlRegex = /\b(https?:\/\/[^\s]+)/g;
    //const text = "Text: улица Чингиза Айтматова, 58 Астана https://yandex.ru/navi?whatshere%5Bpoint%5D=71.37350717913684%2C51.157716914725434&whatshere%5Bzoom%5D=16.715677&ll=71.37350717913684%2C51.15771691433038&z=16.715677&si=my3dq82w71a4nb4rf5nzwp5nxg";
    let urlWrappedText = content.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });

    const telRegex = /\[(.+?)\]/g;
    let url_tlf_WrappedText = urlWrappedText.replace(telRegex, (match, telText) => {
        const telNumber = telText.replace(/-/g, '');
        return `<a href="tel:${telNumber}">${telText}</a>`;
      });
    return <span dangerouslySetInnerHTML={{ __html: url_tlf_WrappedText }} />;
  };